@if (contractsConfig) {
    <generic-list-manager [config]="contractsConfig"></generic-list-manager>
}
